/**
 * Where a signed-in user's "home" is, by role.
 *
 * This existed in four hand-copied places and they drifted: the root `/` route
 * routed admins to `/admin`, while the login page sent everyone to
 * `/dashboard`, so an admin who signed in landed on the learner view — the
 * exact bug the root route's comment complained about. One definition, so the
 * next caller cannot disagree with this one.
 *
 * Impersonation rule, kept from the original: an ADMIN who is impersonating a
 * user is treated as a STUDENT, because they are looking at the app as that
 * user and belong in the learner view.
 */

export type HomeRole = string | null | undefined;

export function roleHomePath(role: HomeRole, isImpersonating = false): string {
  const effectiveRole = isImpersonating
    ? role === "ADMIN"
      ? "STUDENT"
      : role || "STUDENT"
    : role;

  if (effectiveRole === "ADMIN") return "/admin";
  if (effectiveRole === "CURATOR") return "/curator";
  return "/dashboard";
}
